import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Flame, Phone, Menu as MenuIcon, X, Lock } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "@/data";

const LINKS = [
  { label: "Menu", href: "#menu" },
  { label: "The Shop", href: "#shop" },
  { label: "Gallery", href: "#gallery" },
  { label: "Order", href: "/order" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-coal-900/85 border-b border-black/10" data-testid="site-nav">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2" data-testid="nav-logo">
          <Flame className="w-5 h-5 text-ember" />
          <span className="font-display text-2xl tracking-wide">AVANTI</span>
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) =>
            l.label === "Order" ? (
              <a
                key={l.label}
                href={l.href}
                data-testid="nav-link-order"
                className="bg-ember hover:bg-ember-hover text-white font-display text-2xl tracking-widest px-8 py-2.5 ember-glow hover:scale-105 transition-[transform,background-color] duration-300"
              >
                ORDER NOW
              </a>
            ) : (
              <a
                key={l.label}
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className="font-mono text-xs tracking-[0.2em] uppercase text-zinc-400 hover:text-ember transition-colors duration-300"
              >
                {l.label}
              </a>
            )
          )}
        </nav>
        <div className="flex items-center gap-3">
          <a
            href="/owner"
            data-testid="nav-admin-button"
            className="hidden sm:inline-flex items-center gap-2 border border-zinc-800 hover:border-ember text-zinc-400 hover:text-ember font-mono text-xs tracking-[0.2em] uppercase px-4 py-2 transition-colors duration-300"
          >
            <Lock className="w-3.5 h-3.5" />
            Admin
          </a>
          <a
            href={PHONE_TEL}
            data-testid="nav-call-button"
            className="hidden sm:inline-flex items-center gap-2 border border-zinc-800 hover:border-ember text-zinc-400 hover:text-ember font-semibold text-sm px-5 py-2 transition-colors duration-300"
          >
            <Phone className="w-4 h-4" />
            {PHONE_DISPLAY}
          </a>
          <button
            className="md:hidden text-ink"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
            data-testid="nav-mobile-toggle"
          >
            {open ? <X className="w-6 h-6" /> : <MenuIcon className="w-6 h-6" />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="md:hidden overflow-hidden bg-coal-800 border-t border-black/10"
            data-testid="nav-mobile-menu"
          >
            <div className="px-6 py-4 flex flex-col gap-4">
              {LINKS.map((l) =>
                l.label === "Order" ? (
                  <a
                    key={l.label}
                    href={l.href}
                    onClick={() => setOpen(false)}
                    data-testid="nav-link-order-mobile"
                    className="inline-block bg-ember text-white font-display text-2xl tracking-widest text-center px-6 py-3"
                  >
                    ORDER NOW
                  </a>
                ) : (
                  <a
                    key={l.label}
                    href={l.href}
                    onClick={() => setOpen(false)}
                    className="font-mono text-xs tracking-[0.2em] uppercase text-zinc-300"
                  >
                    {l.label}
                  </a>
                )
              )}
              <a href={PHONE_TEL} className="inline-flex items-center gap-2 text-ember font-semibold text-sm">
                <Phone className="w-4 h-4" /> {PHONE_DISPLAY}
              </a>
              <a href="/owner" className="inline-flex items-center gap-2 font-mono text-xs tracking-[0.2em] uppercase text-zinc-400 hover:text-ember transition-colors duration-300" data-testid="nav-admin-mobile" onClick={() => setOpen(false)}>
                <Lock className="w-4 h-4" /> Admin Login
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}
